// import SectionNewsletter from "@cs/screens/landing-page/section-newsletter/NewsletterSection";
import { useTranslation } from "next-i18next";
import { NextSeo } from "next-seo";
import CountriesBenefitsRequirements from "./sections/CountriesBenefitsRequirements/CountriesBenefitsRequirements";
import CountriesContent from "./sections/CountriesContent/CountriesContent";
// import CountriesForm from "./sections/CountriesForm/CountriesForm";
import CountriesHero from "./sections/CountriesHero/CountriesHero";

const CountriesScreen = () => {
  const {t} = useTranslation("olympiad")
  
  return (
    <>
      <NextSeo title={t("countries.cards-info-text-2")} />
      <CountriesHero />
      <CountriesContent />
      <CountriesBenefitsRequirements />
      {/* <CountriesForm /> */}
      {/* <SectionNewsletter /> */}
    </>
  )
}

export default CountriesScreen;